module.exports = __webpack_public_path__ + "static/bosede-282c8d60c78a5f2233416590fc9e06fd.jpg";